export const ssfeaturesTokens = {
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  color: {
    text: "#f8fafc",
    textMuted: "rgba(226, 232, 240, 0.82)",
    textSubtle: "rgba(148, 163, 184, 0.92)",
    accent: "#60a5fa",
    accentStrong: "#3b82f6",
    accentSoft: "rgba(59, 130, 246, 0.14)",
    success: "#4ade80",
    warning: "#fbbf24",
    error: "#f87171",
  },
  surface: {
    base: "#081323",
    raised: "linear-gradient(145deg, #122038 0%, #081122 100%)",
    soft: "#0a1628",
    hover: "rgba(30, 64, 175, 0.18)",
  },
  border: {
    subtle: "1px solid rgba(96, 165, 250, 0.16)",
    default: "1px solid rgba(96, 165, 250, 0.22)",
    strong: "1px solid rgba(96, 165, 250, 0.42)",
  },
  radius: {
    small: "8px",
    control: "10px",
    card: "14px",
    panel: "18px",
  },
  shadow: {
    card: "0 8px 24px rgba(2, 8, 23, 0.28)",
    panel: "0 12px 36px rgba(2, 8, 23, 0.32)",
    focus: "0 0 0 3px rgba(96, 165, 250, 0.32)",
  },
  motion: {
    fast: "160ms cubic-bezier(0.4, 0, 0.2, 1)",
    standard: "240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
};

export const ssfeaturesPagePaddingSx = {
  px: { xs: 2, sm: 3, md: 4 },
};

export const ssfeaturesFocusSx = {
  "&:focus-visible": {
    outline: "2px solid #93c5fd",
    outlineOffset: "3px",
    boxShadow: ssfeaturesTokens.shadow.focus,
  },
};

export const ssfeaturesPanelSx = {
  backgroundColor: "#081323",
  backgroundImage: ssfeaturesTokens.surface.raised,
  border: ssfeaturesTokens.border.subtle,
  borderRadius: ssfeaturesTokens.radius.panel,
  boxShadow: ssfeaturesTokens.shadow.panel,
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  overflow: "hidden",
};

export const ssfeaturesCardSx = {
  backgroundColor: ssfeaturesTokens.surface.soft,
  backgroundImage: "none",
  border: ssfeaturesTokens.border.subtle,
  borderRadius: ssfeaturesTokens.radius.card,
  boxShadow: ssfeaturesTokens.shadow.card,
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
};

export const ssfeaturesDialogPaperSx = {
  ...ssfeaturesPanelSx,
  color: ssfeaturesTokens.color.text,
  backgroundColor: "#081426",
  backgroundImage: "linear-gradient(155deg, #10213b 0%, #081426 58%, #06101f 100%)",
  border: "1px solid rgba(96, 165, 250, 0.3)",
  boxShadow: "0 28px 90px rgba(0, 0, 0, 0.72)",
  overflow: "hidden",
};

export const ssfeaturesDialogTitleSx = {
  px: { xs: 2.25, sm: 3 },
  pt: { xs: 2.25, sm: 2.75 },
  pb: 1.5,
  color: ssfeaturesTokens.color.text,
  fontFamily: ssfeaturesTokens.fontFamily,
  fontWeight: 700,
  fontSize: { xs: "1.15rem", sm: "1.3rem" },
  letterSpacing: "-0.015em",
};

export const ssfeaturesDialogContentSx = {
  px: { xs: 2.25, sm: 3 },
  py: 1.5,
};

export const ssfeaturesDialogActionsSx = {
  px: { xs: 2.25, sm: 3 },
  pt: 1.5,
  pb: { xs: 2.25, sm: 2.75 },
  gap: 1,
  flexWrap: "wrap",
};

export const ssfeaturesTableSx = {
  width: "100%",
  tableLayout: "auto",
  "& .MuiTableCell-root": {
    borderColor: "rgba(148, 163, 184, 0.12)",
    px: 2,
    py: 1.2,
    color: ssfeaturesTokens.color.textMuted,
    fontSize: "0.8125rem",
    lineHeight: 1.45,
    verticalAlign: "middle",
  },
  "& .MuiTableCell-head": {
    color: "#bfdbfe",
    backgroundColor: "#101d32",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.07em",
    lineHeight: 1.3,
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    borderBottom: "1px solid rgba(96, 165, 250, 0.24)",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    backgroundColor: "#0a1628",
    transition: `background-color ${ssfeaturesTokens.motion.fast}`,
  },
  "& .MuiTableBody-root .MuiTableRow-root:hover": {
    backgroundColor: "#10233d",
  },
};

export const ssfeaturesTableContainerSx = {
  width: "100%",
  boxSizing: "border-box",
  overflowX: "auto",
  backgroundColor: "#0a1628",
  backgroundImage: "none",
  border: ssfeaturesTokens.border.subtle,
  borderRadius: ssfeaturesTokens.radius.card,
  boxShadow: ssfeaturesTokens.shadow.card,
};

export const ssfeaturesTableHeaderActionSx = {
  ...ssfeaturesFocusSx,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    color: "#ffffff",
    backgroundColor: "#142945",
  },
};

export const ssfeaturesTableFooterSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 2,
  minHeight: 56,
  px: { xs: 1.5, sm: 2 },
  py: 1.25,
  backgroundColor: "#0d1b30",
  borderTop: "1px solid rgba(96,165,250,0.16)",
};

export const ssfeaturesTabButtonBaseSx = {
  ...ssfeaturesFocusSx,
  minHeight: 36,
  minWidth: 0,
  px: { xs: 1.35, sm: 1.7 },
  py: 0.85,
  borderRadius: "10px",
  textTransform: "none",
  fontFamily: ssfeaturesTokens.fontFamily,
  fontWeight: 650,
  fontSize: "0.84rem",
  lineHeight: 1,
  whiteSpace: "nowrap",
  gap: 0.85,
  border: "1px solid transparent",
  boxShadow: "none",
  transition: `color ${ssfeaturesTokens.motion.fast}, background-color ${ssfeaturesTokens.motion.fast}, border-color ${ssfeaturesTokens.motion.fast}`,
};

export const ssfeaturesTabButtonSx = {
  color: "rgba(226, 232, 240, 0.78)",
  backgroundColor: "transparent",
  border: "1px solid transparent",
  "&:hover": {
    color: "#ffffff",
    backgroundColor: "rgba(59, 130, 246, 0.14)",
    borderColor: "transparent",
  },
};

export const ssfeaturesTabButtonSelectedSx = {
  color: "#ffffff",
  backgroundColor: "#2563eb",
  border: "1px solid rgba(147, 197, 253, 0.35)",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#1d4ed8",
    borderColor: "rgba(147, 197, 253, 0.45)",
  },
};
